export default __webpack_public_path__ + "static/icon-22-2-ff6ae10204e04099d67a427ca7dd92db.png";